import React, { lazy } from 'react';
import { MapPin, Building2 } from 'lucide-react';
import { Badge } from './ui/Badge';
interface ProjectCardProps {
  client: string;
  project: string;
  location: string;
  status: 'Completed' | 'On Progress' | 'On Going' | 'Concept Design';
  year?: string;
  image?: string;
}
export function ProjectCard({
  client,
  project,
  location,
  status,
  year,
  image
}: ProjectCardProps) {
  const statusVariant = {
    Completed: 'success',
    'On Progress': 'warning',
    'On Going': 'warning',
    'Concept Design': 'default'
  } as const;
  return <article className="bg-white border border-wkm-slate-200 rounded-xl overflow-hidden hover:shadow-xl hover:border-wkm-gold-300 transition-all duration-300 group" data-id="element-192">
      <div className="h-56 bg-wkm-slate-100 relative overflow-hidden" data-id="element-193">
        {image ? <img src={image} alt={`${project} - ${client}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" data-id="element-194" /> : <div className="absolute inset-0 flex items-center justify-center text-wkm-slate-400 bg-wkm-slate-100" data-id="element-195">
            <Building2 className="w-16 h-16 opacity-20" data-id="element-196" />
          </div>}
        <div className="absolute inset-0 bg-gradient-to-t from-wkm-navy-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-197"></div>
        <div className="absolute top-3 right-3" data-id="element-198">
          <Badge variant={statusVariant[status]} data-id="element-199">{status}</Badge>
        </div>
      </div>
      <div className="p-6" data-id="element-200">
        <div className="text-xs font-semibold text-wkm-gold-600 uppercase tracking-wide mb-2" data-id="element-201">
          {client}
        </div>
        <h3 className="text-lg font-bold text-wkm-navy-900 mb-3 group-hover:text-wkm-gold-600 transition-colors line-clamp-2 min-h-[3.5rem]" data-id="element-202">
          {project}
        </h3>
        <div className="flex items-center text-wkm-slate-500 text-sm mt-4" data-id="element-203">
          <MapPin className="w-4 h-4 mr-1.5 text-wkm-gold-500 flex-shrink-0" data-id="element-204" />
          <span className="truncate" data-id="element-205">{location}</span>
          {year && <>
              <span className="mx-2 flex-shrink-0" data-id="element-206">•</span>
              <span className="flex-shrink-0" data-id="element-207">{year}</span>
            </>}
        </div>
      </div>
    </article>;
}